import { render, staticRenderFns } from "./UniversitySurveyReport.vue?vue&type=template&id=7dcdf3a4&scoped=true"
import script from "./UniversitySurveyReport.vue?vue&type=script&lang=js"
export * from "./UniversitySurveyReport.vue?vue&type=script&lang=js"
import style0 from "./UniversitySurveyReport.vue?vue&type=style&index=0&id=7dcdf3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcdf3a4",
  null
  
)

export default component.exports